<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Enable Multi Factor Authentication</div>

    <div class="modal-body">
      Multi Factor Authentication is required. Please set up a TOTP generator in our account management.
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none"></span>
      <span class="modal-footer-center cl-spacing-box cl-spacing-none"></span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
         <a  [href]="castlabs_idp_mfa_setup"
            class="btn btn-sm cl-btn-primary it-ok"><span>Go to Castlabs' account management</span><i class="fas fa-angle-right"></i>
                    </a></span>
    </div>
  </div>
</div>
